import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from '../../../utils/createSignedRequest';
import { API_URL } from './utils/constants';

/**
 * A single-use ticket for opening the chat WebSocket as the signed-in user,
 * good for a minute: `{ ticket, expiresInSeconds }`. See createChatSocketUrl.
 */
export const createChatSocketTicket = async () => {
  const apiPath = 'chat/socket-ticket';
  const body = {};
  const request = {
    url: `${API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body), // aws4 looks for body; axios for data
    data: body,
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
